import * as e from "react";
const c = (v) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...v
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.795 20.006v.996H5v-.996h14.795zm-7.89-14.248v.898c-.567 0-.99.057-1.27.171-.28.114-.463.277-.547.488-.085.212-.127.513-.127.904v5.517c0 .567.028 1.063.083 1.49.055.426.141.799.259 1.118.221.527.597.949 1.128 1.264.53.316 1.115.474 1.753.474.683 0 1.32-.168 1.909-.503.589-.335.997-.77 1.225-1.304.183-.416.301-.848.357-1.294.055-.445.083-.978.083-1.596V8.619c0-.43-.013-.749-.04-.957a1.158 1.158 0 00-.214-.552c-.117-.16-.311-.275-.581-.346-.27-.072-.643-.108-1.118-.108v-.898h4.873v.898c-.593 0-1.018.069-1.275.205-.257.137-.415.332-.473.586-.059.254-.088.645-.088 1.172v4.883c0 .898-.031 1.574-.093 2.026-.062.453-.226.91-.493 1.372-.495.892-1.187 1.506-2.075 1.841-.889.335-1.743.503-2.564.503-.605 0-1.229-.08-1.87-.24a5.765 5.765 0 01-1.792-.785 3.53 3.53 0 01-1.26-1.436 5.349 5.349 0 01-.361-.981 4.82 4.82 0 01-.151-.928 21.16 21.16 0 01-.025-1.138l-.02-5.517c0-.573-.112-.977-.336-1.211-.225-.235-.75-.352-1.577-.352v-.898h6.68z",
      fill: "#2d6ded"
    }
  )
), t = c;
export {
  t as default
};
